import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import {
  AsyncCallArgs,
  CardSpg,
  GridItem,
  InputFormField,
  TextareaFormField,
  FileUploadButton,
  shouldShowFieldError,
  getFieldError,
  handleFormSubmission,
  useAsyncCall,
  SubmitFormButton,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { Alert, CardContent, Typography } from "@mui/material";
import { FormProvider } from "react-hook-form";
import { feedbackInitialValues } from "../../../init/feedbackInitialValues";
import { feedbackSubmission, uploadFile } from "../../../axios/api/services";
import { toast } from "react-toastify";
import React from "react";
import { GridContainer } from "@duosoftbg/nacid-components";
import { FeedbackDetails } from "../../../types/feedbackTypes";
import { createFeedbackValidationSchema } from "../../../yup/schema/feedback/feedbackValidationSchema";
import FileDetails from "../../components/common/file/FileDetails";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Feedback = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();

  const { methods } = useReactHookForm<FeedbackDetails>({
    defaultValues: feedbackInitialValues,
    validationSchema: createFeedbackValidationSchema,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onFileChange = async (e) => {
    const token = await executeRecaptcha("PortalFileUpload");
    const uploadFeedbackFile: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: uploadFile(e.target.files[0], token, null),
      reactHooksForm: { methods },
      onSuccess: (response) => {
        const file = { ...response };
        methods.setValue("file", file);
        methods.clearErrors("file");
      },
      onValidationError: () => {
        methods.setValue("file", feedbackInitialValues.file);
      },
    };
    asyncCall(uploadFeedbackFile);
  };

  const onSubmit = async (values) => {
    const token = await executeRecaptcha("PortalFeedbackSubmit");
    const asyncRegistration: AsyncCallArgs = {
      withGlobalBackdrop: true,
      reactHooksForm: { methods },
      promise: feedbackSubmission(values, token),
      onSuccess: () => {
        methods.reset(feedbackInitialValues, { keepIsSubmitted: true, keepSubmitCount: true });
        toast.success(t("m.feedback.submit.success"));
      },
    };
    asyncCall(asyncRegistration);
  };

  return (
    <PageWrapper title={t("t.page.feedback")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <FormProvider {...methods}>
            <form onSubmit={handleFormSubmission({ methods, onSubmitFn: onSubmit, t })}>
              {shouldShowFieldError("captchaToken", methods.formState, methods.getFieldState) ? (
                <Alert severity={"error"}>{getFieldError("captchaToken", methods.getFieldState)}</Alert>
              ) : null}
              <GridContainer spacing={5}>
                <GridItem sm={12} md={12}>
                  <InputFormField required={true} fieldName={"name"} labelCode={"l.person.name"} />
                </GridItem>
                <GridItem sm={12} md={12}>
                  <TextareaFormField required={true} fieldName={"text"} labelCode={"l.feedback"} />
                </GridItem>
                <GridItem sm={12} md={12}>
                  <FileUploadButton onFileChange={onFileChange} id="file-upload-modal-file" required />
                  <FileDetails hint={"m.file.hint"} uploadError={methods.formState.errors?.file as any} />
                </GridItem>
                <GridItem sm={12} md={12}>
                  <Typography align={"left"}>
                    <SubmitFormButton fullWidth label={"l.btn.submit"} />
                  </Typography>
                </GridItem>
              </GridContainer>
            </form>
          </FormProvider>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default Feedback;
